import React from 'react';

interface RequiredApiNoticeProps {
  apis: string[];
  missingFields?: string[];
}

const RequiredApiNotice: React.FC<RequiredApiNoticeProps> = ({ apis, missingFields = [] }) => {
  if (!apis.length && !missingFields.length) return null;

  return (
    <div
      style={{
        marginTop: '16px',
        padding: '12px 14px',
        backgroundColor: '#fff8e1',
        border: '1px solid #ffe082',
        borderRadius: '8px',
      }}
    >
      <div style={{ fontSize: '13px', fontWeight: 700, color: '#8d6e63', marginBottom: '6px' }}>
        Missing data detected
      </div>
      {missingFields.length > 0 && (
        <div style={{ fontSize: '12px', color: '#6d4c41', marginBottom: '6px' }}>
          Missing fields: {missingFields.join(', ')}
        </div>
      )}
      <div style={{ fontSize: '12px', color: '#5d4037' }}>
        Required API/source: {apis.join(' | ')}
      </div>
    </div>
  );
};

export default RequiredApiNotice;
